import { useEffect, useState } from "react";

/**
 * Hook that returns true only when the page is fully loaded
 * (all JS, CSS, images, etc.)
 */
export const usePageLoaded = () => {
	const [isPageLoaded, setIsPageLoaded] = useState(false);

	useEffect(() => {
		if (document.readyState === "complete") {
			setIsPageLoaded(true);
			return;
		}

		const handleLoad = () => setIsPageLoaded(true);
		window.addEventListener("load", handleLoad);
		return () => window.removeEventListener("load", handleLoad);
	}, []);

	return isPageLoaded;
};
